import { render, staticRenderFns } from "./CDataTable.vue?vue&type=template&id=7780f490&scoped=true"
import script from "./CDataTable.vue?vue&type=script&lang=js"
export * from "./CDataTable.vue?vue&type=script&lang=js"
import style0 from "./CDataTable.vue?vue&type=style&index=0&id=7780f490&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7780f490",
  null
  
)

export default component.exports